import { Group, Stack, Text, Title } from '@mantine/core';
import { ReactElement, ReactNode } from 'react';

export interface PatientCentralPageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PatientCentralPageHeader({ title, subtitle, actions }: PatientCentralPageHeaderProps): ReactElement {
  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap" px="md" py="sm">
      <Stack gap={2}>
        <Title order={3}>{title}</Title>
        {subtitle && (
          <Text size="sm" c="dimmed">
            {subtitle}
          </Text>
        )}
      </Stack>
      {actions}
    </Group>
  );
}
